import { defineMessages } from 'react-intl';

export default defineMessages({
  disclaimer: {
    id: 'The content in this publication is presented for informative purposes only. In no sense is this information intended to provide diagnoses or act as a substitute for the work of a qualified professional. For this we recommend that you contact a reliable specialist.',
    defaultMessage: 'The content in this publication is presented for informative purposes only. In no sense is this information intended to provide diagnoses or act as a substitute for the work of a qualified professional. For this we recommend that you contact a reliable specialist.',
  },
  lastUpdate: {
    id: 'Last updated: {lastUpdate}',
    defaultMessage: 'Last updated: {lastUpdate}'
  }
});
